import { initializeGraph } from './generate-graph';
import { fillMainContainerInnerHtml } from "./fill-html-content";
export { initializeGraph } from './generate-graph';
export const initializeHtmlAndGraph = (cssSelector, options) => {
    fillMainContainerInnerHtml(cssSelector, options);
    initializeGraph();
};
//# sourceMappingURL=index.js.map